// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2027":"8c68d6113632810f","2888":"7f61ccc87bc43b7b","5964":"70dca3f62f68dec8","7287":"bb316c81c50a5d4c","8737":"bb316c81c50a5d4c","9873":"bb316c81c50a5d4c"}[chunkId] + ".css";
};